import { render, staticRenderFns } from "./BannerCarousel.vue?vue&type=template&id=a567931e&scoped=true&"
import script from "./BannerCarousel.vue?vue&type=script&lang=js&"
export * from "./BannerCarousel.vue?vue&type=script&lang=js&"
import style0 from "./BannerCarousel.vue?vue&type=style&index=0&id=a567931e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a567931e",
  null
  
)

export default component.exports